(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Closes sibling <details> rows within an accordion when one is opened,
  // if that accordion instance has data-close-others="true".
  //
  // The native `toggle` event on <details> does not bubble, so we attach
  // the listener in the capture phase on the document instead of trying
  // to delegate via bubbling.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;

      const accordion = details.closest('.accordion');
      if (!accordion || accordion.dataset.closeOthers !== 'true') return;

      accordion.querySelectorAll('details[open]').forEach((otherDetails) => {
        if (otherDetails !== details) {
          otherDetails.removeAttribute('open');
        }
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
